import { getGraphQLClient } from 'utilities/graphql';

import GetSuggestedWorkspacesQuery from './GetSuggestedWorkspacesQuery.graphql';
import RequestToJoinWorkspace from './RequestToJoinWorkspace.graphql';

export const getSuggestedWorkspacesQuery = () => {
  const client = getGraphQLClient();

  return client.query({
    query: GetSuggestedWorkspacesQuery,
  });
};

export const requestToJoinWorkspace = workspaceId => {
  const client = getGraphQLClient();

  return client.mutate({
    mutation: RequestToJoinWorkspace,
    variables: { workspaceId },
  });
};
